import { Toaster } from 'react-hot-toast';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Auth
import Login from './pages/Auth/Login';

// Dashboard
import Dashboard from './pages/Dashboard/Dashboard';

// Agent Management
import AgentDetails from './pages/AgentManagement/AgentDetails';
import AgentManagement from './pages/AgentManagement/AgentManagement';
import CreateAgent from './pages/AgentManagement/CreateAgent';

// Cars Management
import CarDetails from './pages/CarsManagement/CarDetails';
import CarsManagement from './pages/CarsManagement/CarsManagement';

// Sellers Management
import CreateSeller from './pages/SellersManagement/CreateSeller';
import SellerDetails from './pages/SellersManagement/SellerDetails';
import SellersManagement from './pages/SellersManagement/SellersManagement';

// Buyers Management
import BuyerDetails from './pages/BuyersManagement/BuyerDetails';
import BuyersManagement from './pages/BuyersManagement/BuyersManagement';


// Analytics
import Analytics from './pages/Analytics/Analytics';

// Membership Management
import MembershipManagement from './pages/MembershipManagement/MembershipManagement';

// Team Management
import TeamManagement from './pages/TeamManagement/TeamManagement';

// Platform Oversight
import PlatformOversight from './pages/PlatformOversight/PlatformOversight';

// Employee Monitoring
import EmployeeMonitoring from './pages/EmployeeMonitoring/EmployeeMonitoring';

// Promotional Codes
import CouponManagement from './pages/CouponManagement/CouponManagement';

// Notifications
import NotificationsBroadcast from './pages/Notifications/NotificationsBroadcast';

// App Settings
import BuyerAppSettings from './pages/AppSettings/BuyerAppSettings';
import SellerAppSettings from './pages/AppSettings/SellerAppSettings';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Route - Login */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            
            {/* Agent Management Routes */}
            <Route path="agents" element={<AgentManagement />} />
            <Route path="agents/create" element={<CreateAgent />} />
            <Route path="agents/:id" element={<AgentDetails />} />
            
            {/* Cars Management Routes */}
            <Route path="cars" element={<CarsManagement />} />
            <Route path="cars/:id" element={<CarDetails />} />
            
            {/* Sellers Management Routes */}
            <Route path="sellers" element={<SellersManagement />} />
            <Route path="sellers/create" element={<CreateSeller />} />
            <Route path="sellers/:id" element={<SellerDetails />} />
            
            {/* Buyers Management Routes */}
            <Route path="buyers" element={<BuyersManagement />} />
            <Route path="buyers/:id" element={<BuyerDetails />} />
            
            
            {/* Analytics */}
            <Route path="analytics" element={<Analytics />} />
            
            {/* Membership Management */}
            <Route path="memberships" element={<MembershipManagement />} />

            {/* Team Management */}
            <Route path="team" element={<TeamManagement />} />

            {/* Platform Oversight */}
            <Route path="oversight" element={<PlatformOversight />} />

            {/* Employee Monitoring */}
            <Route path="employees" element={<EmployeeMonitoring />} />

            {/* Promotional Codes */}
            <Route path="coupons" element={<CouponManagement />} />
            
            {/* Notifications */}
            <Route path="notifications" element={<NotificationsBroadcast />} />
            
            {/* App Settings */}
            <Route path="settings/buyer-app" element={<BuyerAppSettings />} />
            <Route path="settings/seller-app" element={<SellerAppSettings />} />
          </Route>
        </Routes>
        
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#fff',
              color: '#374151',
              boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            },
            success: {
              style: {
                background: '#10b981',
                color: '#fff',
              },
            },
            error: {
              style: {
                background: '#ef4444',
                color: '#fff',
              },
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;